/* Volume savings strip behaviour: variant-aware amounts + copy code */
(function () {
  var initialized = new WeakSet();

  function formatMoney(cents, root) {
    var iso = root.getAttribute('data-currency');
    var symbol = root.getAttribute('data-symbol') || '';
    var value = cents / 100;
    if (iso) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: iso,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
      } catch (e) {}
    }
    return symbol + value.toFixed(2);
  }

  function currentVariantId(root, variants) {
    var ids = {};
    if (variants) {
      for (var i = 0; i < variants.length; i++) ids[String(variants[i].id)] = true;
    }

    var candidates = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (var c = 0; c < candidates.length; c++) {
      var value = String(candidates[c].value || '');
      if (value && (!variants || ids[value])) return value;
    }

    var scoped = root.closest('[id^="shopify-section"]') || document;
    var any = scoped.querySelectorAll('[name="id"]');
    for (var a = 0; a < any.length; a++) {
      var v2 = String(any[a].value || '');
      if (v2 && (!variants || ids[v2])) return v2;
    }

    return String(root.getAttribute('data-initial-variant') || '');
  }

  function render(root) {
    var dataEl = root.querySelector('[data-vs-variants]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      return;
    }
    if (!variants.length) return;

    var id = currentVariantId(root, variants);
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) {
        variant = variants[i];
        break;
      }
    }
    if (!variant) variant = variants[0];

    var price = Number(variant.price) || 0;
    var tiers = root.querySelectorAll('.vs-tier');
    for (var t = 0; t < tiers.length; t++) {
      var tier = tiers[t];
      var qty = Number(tier.getAttribute('data-qty')) || 0;
      var pct = Number(tier.getAttribute('data-pct')) || 0;
      if (!qty) continue;
      var gross = price * qty;
      var saveCents = Math.round(gross * pct / 100);
      var eachCents = Math.round(price * (100 - pct) / 100);
      var saveEl = tier.querySelector('[data-vs-save]');
      var eachEl = tier.querySelector('[data-vs-each]');
      if (saveEl) saveEl.textContent = 'Save ' + formatMoney(saveCents, root);
      if (eachEl) eachEl.textContent = formatMoney(eachCents, root) + ' each';
    }
  }

  function bindCopy(root) {
    var chip = root.querySelector('[data-vs-copy]');
    if (!chip) return;
    var action = chip.querySelector('[data-vs-action]');
    var status = root.querySelector('[data-vs-status]');
    var revertTimer = null;

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.top = '-1000px';
        document.body.appendChild(area);
        area.select();
        try {
          document.execCommand('copy');
          resolve();
        } catch (e) {
          reject(e);
        } finally {
          document.body.removeChild(area);
        }
      });
    }

    chip.addEventListener('click', function () {
      var code = chip.getAttribute('data-vs-copy') || '';
      if (!code) return;
      copyText(code).then(function () {
        chip.classList.add('is-copied');
        if (action) action.textContent = action.getAttribute('data-copied-label') || 'Copied';
        if (status) status.textContent = 'Code ' + code + ' copied to clipboard';
        if (revertTimer) clearTimeout(revertTimer);
        revertTimer = setTimeout(function () {
          chip.classList.remove('is-copied');
          if (action) action.textContent = action.getAttribute('data-copy-label') || 'Copy';
          if (status) status.textContent = '';
        }, 2000);
      }).catch(function () {
        if (status) status.textContent = 'Could not copy automatically, please select the code manually';
      });
    });
  }

  function init(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    render(root);
    bindCopy(root);

    var lastId = currentVariantId(root, null);
    setInterval(function () {
      var id = currentVariantId(root, null);
      if (id !== lastId) {
        lastId = id;
        render(root);
      }
    }, 300);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-vs]:not([data-vs-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-vs-ready', 'true');
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('change', function () { initAll(document); }, true);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
